import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import ClusterLinksSection from './components/ClusterLinksSection';
import WhatIsMentoring from './components/WhatIsMentoring';
import WhyDevelopEmployees from './components/WhyDevelopEmployees';
import WhoToDevelop from './components/WhoToDevelop';
import MentorSkills from './components/MentorSkills';
import NotDoingWork from './components/NotDoingWork';
import DevelopThroughWork from './components/DevelopThroughWork';
import MentoringSystem from './components/MentoringSystem';
import TalentPool from './components/TalentPool';
import MentoringVsAdaptation from './components/MentoringVsAdaptation';
import SpecialistVsMentor from './components/SpecialistVsMentor';
import TrainMentors from './components/TrainMentors';
import WhyProgramsWork from './components/WhyProgramsWork';
import CompanyResults from './components/CompanyResults';
import FormatsSection from './components/FormatsSection';
import HowTrainingGoes from './components/HowTrainingGoes';
import AboutTrainer from './components/AboutTrainer';
import ReadNextSection from './components/ReadNextSection';
import LeadMagnetBlock from '@/components/leadmagnet/LeadMagnetBlock';
import FAQSection from './components/FAQSection';
import FinalCTA from './components/FinalCTA';
import Footer from '@/components/feature/Footer';

const navLinks = [
  { label: 'Навыки', target: 'skills' },
  { label: 'Система', target: 'process' },
  { label: 'Результаты', target: 'results' },
  { label: 'FAQ', target: 'faq' },
];

export default function MentoringDevelopmentPage() {
  return (
    <>
      
      <SeoTitle title="Наставничество и развитие сотрудников | Business Training" />
      <PageJsonLd />

      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={navLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />
        <ClusterLinksSection />
        <WhatIsMentoring />
        <WhyDevelopEmployees />
        <WhoToDevelop />

        <div id="skills">
          <MentorSkills />
        </div>

        <NotDoingWork />
        <DevelopThroughWork />

        <div id="process">
          <MentoringSystem />
        </div>

        <TalentPool />
        <MentoringVsAdaptation />
        <SpecialistVsMentor />
        <TrainMentors />
        <WhyProgramsWork />

        <div id="results">
          <CompanyResults />
        </div>

        <FormatsSection />
        <HowTrainingGoes />
        <AboutTrainer />
        <LeadMagnetBlock variant="compact" />
        <ReadNextSection />
        <FAQSection />
        <FinalCTA />
        <Footer />
      </div>
    </>
  );
}